import React from 'react';
import './PositionsTable.css';
import { Position, QuoteData } from '../services/MetaCopierService';

interface PositionsTableProps {
  positions: Position[];
  onClose: (positionId: string) => void;
  isProcessing: boolean;
  quote: QuoteData | null;
}

const PositionsTable: React.FC<PositionsTableProps> = ({ positions, onClose, isProcessing, quote }) => {
  if (positions.length === 0) {
    return (
      <div className="positions-container">
        <h3 className="positions-title">Open Positions</h3>
        <div className="no-positions">No open positions</div>
      </div>
    );
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getCurrentPrice = (position: Position): number => {
    if (!quote || position.symbol !== quote.symbol) {
      return position.currentPrice;
    }
    // For Buy positions, use bid price (price we can sell at)
    // For Sell positions, use ask price (price we need to buy back at)
    const isBuy = position.type.toLowerCase() === 'buy';
    return isBuy ? quote.bid : quote.ask;
  };

  return (
    <div className="positions-container">
      <h3 className="positions-title">
        Open Positions <span className="position-count">({positions.length})</span>
      </h3>
      <div className="positions-table-wrapper">
        <table className="positions-table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Type</th>
              <th>Volume</th>
              <th>Open Price</th>
              <th>Current</th>
              <th>Profit/Loss</th>
              <th>TP</th>
              <th>SL</th>
              <th>Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {positions.map((position) => {
              const currentPrice = getCurrentPrice(position);
              
              return (
              <tr key={position.id}>
                <td className="symbol-cell">{position.symbol}</td>
                <td>
                  <span className={`type-badge ${position.type.toLowerCase()}`}>
                    {position.type}
                  </span>
                </td>
                <td>{position.volume.toFixed(2)}</td>
                <td>{position.openPrice.toFixed(2)}</td>
                <td>{currentPrice.toFixed(2)}</td>
                <td>
                  <span className={`profit ${position.netProfit >= 0 ? 'positive' : 'negative'}`}>
                    {position.netProfit >= 0 ? '+' : ''}{position.netProfit.toFixed(2)} USD
                  </span>
                </td>
                <td>{position.takeProfit ? position.takeProfit.toFixed(2) : '-'}</td>
                <td>{position.stopLoss ? position.stopLoss.toFixed(2) : '-'}</td>
                <td className="time-cell">{formatDate(position.openTime)}</td>
                <td>
                  <button
                    className="close-button"
                    onClick={() => onClose(position.id)}
                    disabled={isProcessing}
                  >
                    Close
                  </button>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PositionsTable;
